import { logger } from "../utils/logger";

/**
 * Appends an optional startDate/endDate query string to a URL when both are
 * provided. Returns the URL unchanged otherwise.
 * @param {string} url - Base URL
 * @param {string|number} [startDate] - Range start
 * @param {string|number} [endDate] - Range end
 * @returns {string} URL with date-range query appended when applicable
 */
export function appendDateRange(url, startDate, endDate) {
  if (startDate && endDate) {
    return `${url}?startDate=${startDate}&endDate=${endDate}`;
  }
  return url;
}

/**
 * Runs an async request, rethrowing a normalized `{ status: 409 }` on conflict
 * so callers can present a "name already exists" message, while logging and
 * swallowing all other errors (returning `false`).
 * @param {() => Promise<*>} fn - Async function performing the request
 * @param {string} errorMessage - Message to log on non-409 errors
 * @returns {Promise<*|false>} The request result, or false on a handled error
 */
export async function withConflictRethrow(fn, errorMessage) {
  try {
    return await fn();
  } catch (error) {
    if (error.response?.status === 409) {
      throw { status: 409 };
    }
    logger.error(errorMessage, error);
    return false;
  }
}
